/**
 * device service
 */

import Resource from './resource'

export default new Resource('expirechannels')



// WEBPACK FOOTER //
// ./src/libraries/services/expirechannels.js